import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation4({ animation, badge, all_animations }: Props) {
  const [flyingStars, setFlyingStars] = useState<number[]>([])
  const [showBadge, setShowBadge] = useState(false)
  const [showText, setShowText] = useState(false)

  useEffect(() => {
    // Créer des étoiles qui s'envolent
    const starsArray = Array.from({ length: 8 }, (_, i) => i)

    starsArray.forEach((_, index) => {
      setTimeout(() => {
        setFlyingStars(prev => [...prev, index])
      }, index * 150)
    })

    setTimeout(() => setShowBadge(true), 500)
    setTimeout(() => setShowText(true), 1200)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes flyUp {
          0% {
            transform: translateY(0) scale(1) rotate(0deg);
            opacity: 1;
          }
          50% {
            transform: translateY(-100px) scale(1.3) rotate(180deg);
            opacity: 1;
          }
          100% {
            transform: translateY(-200px) scale(0.5) rotate(360deg);
            opacity: 0;
          }
        }
        .fly-up {
          animation: flyUp 1.2s ease-out forwards;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh] relative">
        {/* Étoiles qui s'envolent */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          {flyingStars.map((index) => (
            <div
              key={index}
              className="absolute fly-up text-tessan-yellow text-4xl"
              style={{
                left: `${35 + (index % 4) * 10}%`,
                top: '50%',
                animationDelay: `${index * 0.1}s`
              }}
            >
              ⭐
            </div>
          ))}
        </div>

        {/* Badge central */}
        <div className={`relative z-10 transition-all duration-700 ${showBadge ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}>
          <div className="w-32 h-32 sm:w-40 sm:h-40 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/30 animate-pulse">
            <span className="text-5xl sm:text-7xl">{badge.emoji}</span>
          </div>
        </div>

        {/* Texte */}
        <div className={`mt-6 text-center transition-all duration-500 ${showText ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">
            {badge.name}
          </div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">
            +{badge.points_awarded} points
          </div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">
            {badge.description}
          </div>
        </div>
      </div>
    </AnimationLayout>
  )
}
